import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CustomFormComponent} from 'app/shared/classes/custom-form-component';

interface FileLike {
    name: string;
    type: string;
    size: number;
}

@Component({
    selector: 'file-input',
    templateUrl: './file-input.component.html',
    styleUrls: ['./file-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FileInputComponent),
            multi: true,
        },
    ],
})
export class FileInputComponent extends CustomFormComponent<FileLike | Iterable<FileLike>> implements OnInit {
    static idCounter = 0;

    @Input() multiple = false;
    @Input() accept: string[] | string;

    @ViewChild('nativeInput', {static: false}) $inputEl: ElementRef<HTMLInputElement>;

    get fileName() {
        return this.internalValue
            ? (this.multiple ? [...(<Iterable<FileLike>>this.internalValue)] : [<FileLike>this.internalValue])
                  .map(file => file.name)
                  .join(', ')
            : '';
    }

    get allowedTypes() {
        if (!this.accept) {
            return;
        }
        if (Array.isArray(this.accept)) {
            return this.accept.join(',');
        }
        return this.accept;
    }

    constructor($el: ElementRef, cd: ChangeDetectorRef) {
        super($el, cd);
    }

    ngOnInit() {
        this.id = this.id === undefined ? `fileInput-${++FileInputComponent.idCounter}` : this.id;
    }

    onChange(event: Event) {
        const files: FileList = (<any>event.target).files;
        this.invokeChangeCallback(this.multiple ? files : files[0]);
    }

    onClear() {
        this.invokeChangeCallback(null);
    }
}
